import { addTruthyParamsToUrl, urlWithNext } from "@zapier/url-utils";

const redirectToLogin = () => {
  if (typeof window !== "undefined") {
    const reauthUrl = addTruthyParamsToUrl(
      urlWithNext("/app/login", window.location.pathname),
      {
        reauth: true,
      }
    );
    window.location.href = reauthUrl;
  }
};

export default redirectToLogin;
